import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-number',
  templateUrl: './number.component.html'
})
export class NumberComponent implements OnInit {
  @Input() input: any;
  @Input() group: FormGroup;
  @Input() option: any;
  constructor() { }

  ngOnInit() {
  }

}
